import { useLocation } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import {
  Typography,
  Divider,
  Button
} from "@mui/material";
import { AuthContext } from "src/utils/AuthContext.js";
import { StarsSelect } from "src/components/blocks/StarsSelect.js";
import ShareDialog from "src/components/blocks/dialogs/ShareDialog.js";
import RecommendedCalendars from "src/components/blocks/RecommendedCalendars.js";
import InstructionsLayout from "../InstructionsLayout.js";
import { getPageRoute } from "src/services";
import confetti from 'canvas-confetti';
import { customEvent } from "src/utils/gtag.js";

const SuccessfulCalendarSubscription = () => {
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const [stars, setStars] = useState(0);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  
  const sourceCalendar = location.state ? location.state.calendar ?? null : null;
  const isReminder = location.state?.isReminder ?? false;

  console.log(isReminder);

  const boomTitle = (
    <span style={{ fontWeight: 400 }}>
      <span style={{ fontWeight: 600 }}>Boom!</span> <br /> You're all set.
    </span>
  );

  const description = isReminder 
    ? `Follow the instructions in the reminder to subscribe to "${sourceCalendar?.name}" on your desktop, then sync it with the Google Calendar app on your phone.`
    : (
        <>
          Your calendar will now <b>automatically update</b> whenever `{sourceCalendar?.name}` events are added, changed, or cancelled.
        </>
      );

  useEffect(() => {
    const count = 200;
    const defaults = {
      origin: { y: 0.7 },
      zIndex: 1500,
      colors: ['#000000', '#FFFFFF'], // Black and white colors
    };

    function fire(particleRatio, opts) {
      confetti({
        ...defaults,
        ...opts,
        particleCount: Math.floor(count * particleRatio)
      });
    }

    // First burst - black and white mix
    fire(0.4, {
      spread: 100,
      startVelocity: 55,
      scalar: 0.8,
      colors: ['#000000', '#FFFFFF']
    });

    // Second burst - mostly white
    fire(0.3, {
      spread: 60,
      startVelocity: 45,
      colors: ['#FFFFFF']
    });

    // Third burst - mostly black
    fire(0.3, {
      spread: 80,
      startVelocity: 35,
      colors: ['#000000']
    });

    return () => confetti.reset();
  }, []);

  useEffect(() => {
    customEvent({
      name: "landed_on_subscription_success",
      category: "CalendarSubscription",
      label: "Landed on Calendar Subscription Success Page",
      data: {
        user_id: user?._id,
        user_email: user?.email,
        calendar_handle: sourceCalendar?.handle,
      }
    });
  }, [stars]);

  return (
    <InstructionsLayout nav="home" sx={{ textAlign: "left" }}>
      <Typography variant="h3" sx={{ mb: 2 }}>{boomTitle}</Typography>
      <Typography variant="body1" sx={{ color: "text.primary", mb: 4 }}>
        {description}
      </Typography>
      <Button 
        variant="contained" 
        fullWidth
        onClick={() => setShareDialogOpen(true)}
        sx={{ mb: 2 }}
      >
        Share
      </Button>
      <ShareDialog
        calendar={sourceCalendar}
        handle={sourceCalendar?.handle}
        open={shareDialogOpen}
        setOpen={setShareDialogOpen}
        as="Hidden"
      />
      <Button 
        variant="outlined" 
        fullWidth
        href={getPageRoute("home", "HOME", {}, { tab: user?.tags?.length > 0 ? "foryou" : "discover" })}
      >
        Explore Library
      </Button>
      <Divider sx={{ width: "100%", my: 4 }} />
      <StarsSelect 
        stars={stars} 
        setStars={setStars} 
        calendar={sourceCalendar}
      />
      <Divider sx={{ width: "100%", mt: 4 }} />
      {sourceCalendar && <RecommendedCalendars 
        sourceCalendars={[sourceCalendar]} 
        displayMode="related"
      />}
      <Button 
        variant="contained" 
        size="large" 
        fullWidth
        sx={{ mb: 4 }}
        href={getPageRoute("home", "HOME", {}, { tab: user?.tags?.length > 0 ? "foryou" : "discover" })}
      >
        Discover More Calendars
      </Button>
    </InstructionsLayout>
  );
};

export default SuccessfulCalendarSubscription;